/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-20 15:39:39
 * @LastEditTime: 2020-08-20 15:39:52
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/service/roleService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";

/*
 *获取页面布局
 */
export function getTableHeaderApi(id) {
  return request({
    url: "/api/v1/mine/templates/" + id,
    method: "GET",
    data: {
      templateId: id
    }
  });
}

/*
 *获取页面数据
 */
export function getTableDataApi(idInfo) {
  return request({
    url: "/api/v1/roles" + idInfo,
    method: "GET",
    data: idInfo
  });
}

/*
 *更改编辑数据
 */
export function getChangeDataApi(data) {
  return request({
    url: "/api/v1/roles/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 删除数据
 */
export function deleteDataApi(id) {
  return request({
    url: "/api/v1/roles/" + id,
    method: "DELETE"
  });
}
/*
 *创建数据
 */
export function postDataApi(data) {
  return request({
    url: "/api/v1/roles/",
    method: "POST",
    data: data
  });
}

/*
 *获取关联用户数据
 */
export function getUserApi(idInfo) {
  return request({
    url: "/api/v1/users",
    method: "GET"
  });
}

/*
 *查询关联用户数据
 */
export function getUserItemApi(idInfo) {
  return request({
    url: "/api/v1/users" + idInfo,
    method: "GET"
  });
}



// WEBPACK FOOTER //
// ./src/service/roleService.js